import { useEffect, useState } from 'react';
import { NAVIGATION_ID } from './constants';

export const useNavElement = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>();

  useEffect(() => {
    setAnchorEl(document.getElementById(NAVIGATION_ID));
  }, []);

  return anchorEl;
};
